<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item prop="iccid">
        <el-input v-model="queryParams.iccid" clearable placeholder="ICCID"></el-input>
      </el-form-item>
      <el-form-item prop="msisdn">
        <el-input v-model="queryParams.msisdn" clearable placeholder="MSISDN"></el-input>
      </el-form-item>
      <el-form-item prop="message">
        <el-input v-model="queryParams.message" clearable placeholder="异常信息"></el-input>
      </el-form-item>
      <el-form-item  prop="status" >
        <el-select v-model="queryParams.status" filterable placeholder="状态" @change="search" clearable>
            <el-option value="1" label="已处理"></el-option>
            <el-option value="0" label="未处理"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="dateRange"
          style="width: 240px"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
        <el-button type="primary" class="el-icon-download" @click="handleExport">导出</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" ref="tableData" border   v-loading="loading">
      <el-table-column prop="iccid" label="ICCID" align="center" min-width="160px" fixed>
        <template slot-scope="{row}">
          <el-link type="success" :underline="false" @click='jumpButton(row.iccid)'>{{row.iccid}}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="msisdn" label="MSISDN" align="center" min-width="120px" fixed>
      </el-table-column>
      <el-table-column prop="operationName" label="运营商" align="center"   width="100px"></el-table-column>
      <el-table-column prop="type" label="操作类型" align="center"   width="120px"></el-table-column>
      <el-table-column label="状态" align="center" width="200">
        <template slot-scope="scope">
            <el-switch
                v-model="scope.row.status"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-value="1"
                inactive-value="0"
                active-text="已处理"
                inactive-text="未处理"
                @change="handleStatusChange(scope.row)"
            ></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="message" label="异常信息" align="center"   width="300px"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center"   width="160px"></el-table-column>
      <el-table-column prop="updateTime" label="更新时间" align="center"  width="160px"></el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="initData"
    />
  </div>
</template>
<script>
import {cardExceptionPage, cardExceptionStatus ,cardExceptionExport} from "@/api/api.js"; //获取代理商下拉列表
export default {
  name:"cardException",
  data() {
    return{
      //遮罩层
      loading: true,
      queryParams:{
        iccid:undefined,
        msisdn:undefined,
        message:undefined,
        status:undefined,
      },
      tableData:[],
      dateRange: [],
      folding:false,
      // 排序方式
      sortOrder: "",
      // 排序名称
      sortName: "",
      page: 1,
      pageSize: 10,
      total:0,
      // 状态
    }
  },
  methods: {
    // 获取列表的数据
    initData(){
      let params = {
        model:{
          ...this.addDateRange(this.queryParams, this.dateRange),
        },
        page: this.page,
        pageSize: this.pageSize
      }

      this.loading = true;
      cardExceptionPage(params).then(res => {
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
        this.loading = false;
      })
    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    // 重置
    resetQuery() {
      this.dateRange = [];
      this.resetForm("queryForm");
      this.search();
    },
    handleStatusChange(row) {
      let text = row.status;
      let params = {id:row.id,status:text}
      cardExceptionStatus(params).then(res=>{
        this.$modal.msgSuccess("修改成功");
      }).catch(function() {
        row.status = row.status === "0" ? "1" : "0";
      });
    },
    //导出
    handleExport(){
      let params = {
        ...this.addDateRange(this.queryParams, this.dateRange),
      }
      cardExceptionExport(params).then(res=>{
          this.$notify({
            title: "提示",
            message: "已提交导出，请在任务中心查看进度",
            type: "success"
          });
          setTimeout(()=>{
            this.$router.push({ path: `/taskCenter/missionList`});
          },1000)
      })
    },
    jumpButton(iccid){
      this.$router.push({path:"/card/detail",query:{iccid: iccid}});
    },
  },
  mounted() {

  },
  created() {
    this.initData()
  }
};
</script>
<style scoped lang="less">
</style>


